import React from 'react';
import { t } from 'i18next';
import { NewsletterRecipientStatus, NewsletterStatus } from './NewsletterTypes';

// Renders the status of a newsletter as a badge in the house style of the lists
export const renderNewsletterStatusBadge = (status: NewsletterStatus, small: boolean = false) => (
    <div className='badge-container'>
        <div className={`status-badge newsletter-${status} ${small ? 'small' : ''}`}>
            {t(`newsletters.status.${status}`)}
        </div>
    </div>
);

// Renders the status of a newsletter recipient as a badge
export const renderRecipientStatusBadge = (status: NewsletterRecipientStatus, small: boolean = false) => (
    <div className='badge-container'>
        <div className={`status-badge newsletter-recipient-${status} ${small ? 'small' : ''}`}>
            {t(`newsletters.recipient_status.${status}`)}
        </div>
    </div>
);
